<template>
    <v-container fluid grid-list-sm class="home text-xs-center">
        <v-layout align-center justify-center row pa-5 mb-8>
            <v-flex xs12 sm10 md6>
                <div>
                    <v-text-field label="ค้นหา บ้านเลขที่ หรือ ยูนิต"
                                  placeholder="ค้นหา บ้านเลขที่ หรือ ยูนิต"
                                  outlined
                                  :error="error"
                                  append-outer-icon="mdi-magnify"
                                  @click:append-outer="searchDataCustomer()"
                                  @keypress.enter="searchDataCustomer()"
                                  v-model="searchText">
                    </v-text-field>
                </div>
                <div v-if="items.length > 0 || filterText">
                    <v-text-field label="ค้นหา"
                                  placeholder="ค้นหา"
                                  v-model="filterText">
                    </v-text-field>
                </div>
                <div v-for="(item, key) in items" :key="key" v-if="items.length > 0">
                    <v-row>
                        <v-col cols="11">
                            <v-card class="mx-auto my-auto"
                                    @click="selectedCustomer(item,'select')"
                                    style="border-left:solid 5px #0045AF;background: #e7e8ea">
                                <v-row class="pl-2">
                                    <v-col class="text-center my-auto" cols="3">
                                        <v-avatar color="#0D47A1" size="45">
                                            <span class="white--text headline">{{ item.cs_fullname.charAt(0) }}</span>
                                        </v-avatar>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-card-title>{{ item.cs_fullname }}</v-card-title>
                                        <v-card-text style="color: #000000"
                                                     v-if="item.cs_mobile !== '' && item.cs_mobile !== null">
                                            เบอร์โทร : {{ item.cs_mobile }}
                                        </v-card-text>
                                        <v-card-text style="color: #ff2e34" v-else>ไม่พบเบอร์โทร</v-card-text>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="1" class="pt-5">
                            <v-btn icon @click="selectedCustomer(item,'delete')">
                                <v-icon medium color="#E53935">mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <div v-if="items.length === 0 && search" class="my-8 text-center">
                    <h3>ไม่พบรายชื่อในบ้านเลขที่นี้</h3>
                </div>
                <v-dialog v-model="dialog" max-width="290" persistent>
                    <v-card>
                        <v-card-title>แก้ไขข้อมูล</v-card-title>
                        <v-card-text class="mt-4" v-if="itemSelect.cs_db == 'WRE'">
                            <v-text-field label="ชื่อ"
                                          outlined
                                          v-model="itemSelect.cs_name">
                            </v-text-field>
                            <v-text-field label="สกุล"
                                          outlined
                                          v-model="itemSelect.cs_surname">
                            </v-text-field>
                        </v-card-text>
                        <v-card-text class="mt-4" v-else>
                            <v-text-field label="ชื่อ"
                                          outlined
                                          v-model="itemSelect.cs_name">
                            </v-text-field>
                        </v-card-text>
                        <v-card-text class="mt-4">
                            <v-text-field label="เบอร์โทร"
                                          outlined
                                          type="number"
                                          v-model="itemSelect.cs_mobile">
                            </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <v-btn color="green darken-1" text @click="editCustomer()">
                                ตกลง
                            </v-btn>
                            <v-btn color="red darken-1" text @click="dialog = false">
                                ยกเลิก
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog_delete" max-width="290" persistent>
                    <v-card>
                        <v-card-title>
                            ยืนยันการลบรายชื่อพัสดุ
                        </v-card-title>
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <v-btn color="green darken-1" text @click="deleteCustomer()">
                                ตกลง
                            </v-btn>
                            <v-btn color="red darken-1" text @click="dialog_delete = false">
                                ยกเลิก
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import EventBus from "@/EventBus";
import axios from "@/axios";

export default {
    name: "EditCustomer",
    mounted() {
        window.scrollTo(0, 0)
        EventBus.$emit('set_navigation', {title: 'แก้ไขข้อมูลลูกค้า', back_route: 'main-menu'});
    },
    data() {
        return {
            searchText: '',
            items: [],
            itemsDefault: [],
            itemSelect: [],
            dialog: false,
            dialog_delete: false,
            error: false,
            disabled: true,
            search: false,
            filterText: ''
        }
    },
    methods: {
        async searchDataCustomer() {
            try {
                axios.post("/GetDataCustomer", {
                    searchText: this.searchText,
                    nt_runno: this.getLocalItem().nt_runno,
                }).then((res) => {
                    this.disabled = false
                    this.items = res.data.data
                    this.itemsDefault = res.data.data
                    this.search = true
                    console.log('searchDataCustomer', res.data.data)
                });
            } catch (err) {
                console.log("CheckBarcode", err.message);
            }
        },
        selectedCustomer(data, type) {
            this.itemSelect = data
            if (type === 'select') {
                this.dialog = true
            } else if (type === 'delete') {
                this.dialog_delete = true
            }
        },
        async deleteCustomer() {
            try {
                axios.post("/DeleteCustomer", {
                    cs_runno: this.itemSelect.cs_runno,
                    cs_db: this.itemSelect.cs_db,
                    pd_addr: this.itemSelect.pd_addr,
                    nt_runno: this.getLocalItem().nt_runno,
                    username: this.getLocalItem().user_id,
                }).then((res) => {
                    this.dialog_delete = false
                    console.log('searchDataCustomer', res.data.data)
                    this.searchDataCustomer()
                });
            } catch (err) {
                console.log("CheckBarcode", err.message);
            }
        },
        async editCustomer() {
            if (this.itemSelect.cs_db === 'WRE') {
                try {
                    axios.post("/UpdateCustomer", {
                        cs_runno: this.itemSelect.cs_runno,
                        cs_db: this.itemSelect.cs_db,
                        pd_addr: this.itemSelect.pd_addr,
                        nt_runno: this.getLocalItem().nt_runno,
                        username: this.getLocalItem().user_id,
                        name: this.itemSelect.cs_name,
                        surname: this.itemSelect.cs_surname,
                        tel: this.itemSelect.cs_mobile,
                    }).then((res) => {
                        this.dialog = false
                        console.log('UpdateCustomer', res.data.data)
                        this.searchDataCustomer()
                    });
                } catch (err) {
                    console.log("CheckBarcode", err.message);
                }
            } else {
                try {
                    axios.post("/UpdateCustomer", {
                        cs_runno: this.itemSelect.cs_runno,
                        cs_db: this.itemSelect.cs_db,
                        pd_addr: this.itemSelect.pd_addr,
                        nt_runno: this.getLocalItem().nt_runno,
                        username: this.getLocalItem().user_id,
                        name: this.itemSelect.cs_name,
                        surname: this.itemSelect.cs_name,
                        tel: this.itemSelect.cs_mobile,
                    }).then((res) => {
                        this.dialog = false
                        console.log('UpdateCustomer', res.data.data)
                        this.searchDataCustomer()
                    });
                } catch (err) {
                    console.log("CheckBarcode", err.message);
                }
            }
        }
    },
    watch: {
        filterText: function (val) {
            if (val) {
                this.items = this.filterObject(this.itemsDefault, 'cs_fullname', this.filterText)
            } else {
                this.items = this.itemsDefault
            }
        }
    }
}
</script>

<style scoped>

</style>